module.exports = __webpack_public_path__ + "static/media/je.e0932aed.svg";